import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { AddressBookText } from '../../AddressBookEntry';
import { AddressTypes } from '../../../../utils/enums';
import {
  ShipmentSummaryContainer,
  ContentBox,
  ContentBoxTitle,
  ContentBoxGap,
  ContentBoxGapAddress,
  ContentBoxInfoColumn,
  ContentBoxSubTitle,
  ContentBoxText,
} from './css';

const ShipmentSummary = ({ formData }) => {
  const {
    billTo,
    broker,
  } = formData;

  return (
    <ShipmentSummaryContainer>
      <ContentBox>
        <ContentBoxTitle>{t('ShipperDetailsTitle')}</ContentBoxTitle>
        <ContentBoxGapAddress>
          <AddressBookText contactType={AddressTypes.SHIPPER} formData={formData} />
        </ContentBoxGapAddress>
      </ContentBox>

      <ContentBox>
        <ContentBoxTitle>{t('ConsigneeDetailsTitle')}</ContentBoxTitle>
        <ContentBoxGapAddress>
          <AddressBookText contactType={AddressTypes.CONSIGNEE} formData={formData} />
        </ContentBoxGapAddress>
      </ContentBox>

      <ContentBox>
        <ContentBoxTitle>{t('CustomsBrokerDetails')}</ContentBoxTitle>
        <ContentBoxGapAddress>
          <ContentBoxInfoColumn>
            <ContentBoxSubTitle>{t('ContactName')}</ContentBoxSubTitle>
            <ContentBoxText>{broker.name}</ContentBoxText>
          </ContentBoxInfoColumn>
          <ContentBoxInfoColumn>
            <ContentBoxSubTitle>{t('Email')}</ContentBoxSubTitle>
            <ContentBoxText>{broker.emailAddress}</ContentBoxText>
          </ContentBoxInfoColumn>
          <ContentBoxInfoColumn>
            <ContentBoxSubTitle>{t('PhoneNumber')}</ContentBoxSubTitle>
            <ContentBoxText>{broker.phoneNumber}</ContentBoxText>
          </ContentBoxInfoColumn>
        </ContentBoxGapAddress>
      </ContentBox>

      <ContentBox>
        <ContentBoxTitle>{t('BillingInformation')}</ContentBoxTitle>
        <ContentBoxGap>
          <ContentBoxInfoColumn>
            <ContentBoxSubTitle>{t('BillTo')}</ContentBoxSubTitle>
            <ContentBoxText>{billTo}</ContentBoxText>
          </ContentBoxInfoColumn>
        </ContentBoxGap>
      </ContentBox>
    </ShipmentSummaryContainer>
  );
};

ShipmentSummary.propTypes = {
  formData: PropTypes.shape({
    billTo: PropTypes.string,
    broker: PropTypes.shape({
      name: PropTypes.string,
      emailAddress: PropTypes.string,
      phoneNumber: PropTypes.string,
    }),
  }),
};

export default ShipmentSummary;
